import { TopPage } from '@nutmeglabs/falcon-ui';
import { FalconUIContextProvider } from 'components/FalconUIContextProvider/FalconUIContextProvider';
import { ReduxState } from 'ducks';
import { useSelector } from 'react-redux';
import { OgpTags } from './OgpTags';
import dynamic from 'next/dynamic';

interface Props {
  topPageData: TopPage;
}

const Header = dynamic(() => import('@nutmeglabs/falcon-ui').then((mod) => mod.Header), {
  ssr: false,
});
const Footer = dynamic(() => import('@nutmeglabs/falcon-ui').then((mod) => mod.Footer), {
  ssr: false,
});
const KeyVisual = dynamic(() => import('@nutmeglabs/falcon-ui').then((mod) => mod.KeyVisual), {
  ssr: false,
});
const SectionView = dynamic(() => import('@nutmeglabs/falcon-ui').then((mod) => mod.SectionView), {
  ssr: false,
});

export const CustomTopPage = ({ topPageData }: Props) => {
  const settings = useSelector((state: ReduxState) => state.server.settings.all);
  const operatingHoursRules = settings?.operating_hours_rules;
  let operatingHoursDescription = '';
  if (operatingHoursRules && operatingHoursRules.length > 0) {
    operatingHoursDescription = `${operatingHoursRules[0].start_time_local} - ${operatingHoursRules[0].end_time_local}`;
  }
  const products = useSelector((state: ReduxState) => state.server.productSummaries.all);

  return (
    <FalconUIContextProvider>
      <OgpTags topPageData={topPageData} />
      <div className="base-wrap" style={{ background: '#fff' }}>
        <Header data={topPageData} />

        <main className="base-main" style={{ marginBottom: 0 }}>
          <KeyVisual data={topPageData} />

          {topPageData.sections?.map((section, index) => {
            return <SectionView key={index} data={section} products={products as any} />;
          })}
        </main>

        <Footer
          data={topPageData}
          orgInfo={{
            phone: settings?.supplier_phone ?? '',
            email: settings?.supplier_email ?? '',
            address: settings?.supplier_address ?? '',
            operatingHoursDescription,
            hideFooterJapaneseTermsLink:
              settings?.booking_widget_design_params?.hide_footer_japanese_terms_link ?? false,
            snsIds: settings?.sns_ids ?? [],
            showTravelAgencyRegistrationForm: false,
          }}
        />
      </div>
    </FalconUIContextProvider>
  );
};
